import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import { notificationHelper } from '../../utils/helper';
import { UserProfileItem } from '../UserProfileItem';
import UserProfileFooter from './UserProfileFooter';
import UserProfileLogout from './UserProfileLogout';
import moment from 'moment';
import UserAvatar from '../UserAvatar';
import { dateFormat, EMPTY_OBJECT, LANGUAGE_OPTIONS } from '../../constants/Constants';
import { removeUserImageApi, uploadUserImageApi, logoutFromToken } from '../../api/Header';
import { showConfirm } from '../../utils/helper.confirm';
import TokenManager from '../../utils/TokenManager';
import './UserProfile.scss';
const {
  INTL_ENABLE
} = process.env;
function UserProfile(props) {
  const {
    userData,
    handleOpenDrawer
  } = props;
  const [userContact, setUserContact] = useState(userData.phone);
  const [showWarning, setShowWarning] = useState(false);
  const [isContactUpdated, setIsContactUpdated] = useState(false);
  const [currentAvatarPicture, setCurrentAvatarPicture] = useState(userData.profile_pic);
  const [isEditAvatarPicture, setIsEditAvatarPicture] = useState(false);
  const [defaultLanguage, setDefaultLanguage] = useState(userData === null || userData === void 0 ? void 0 : userData.preferred_language);
  const [isUpdateLanguage, setIsUpdateLanguage] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const [isUserDataUpdated, setIsUserDataUpdated] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  useEffect(() => {
    setUserContact(userData.phone);
    setCurrentAvatarPicture(userData === null || userData === void 0 ? void 0 : userData.profile_pic);
    setDefaultLanguage(userData === null || userData === void 0 ? void 0 : userData.preferred_language);
  }, [userData]);
  useEffect(() => {
    if (isEditAvatarPicture || isContactUpdated || isUpdateLanguage) {
      setShowFooter(true);
    } else {
      setShowFooter(false);
    }
  }, [isEditAvatarPicture, isContactUpdated, isUpdateLanguage]);
  const handleDrawerClose = useCallback(() => {
    handleOpenDrawer();
    setIsContactUpdated(false);
    setIsEditAvatarPicture(false);
  }, [handleOpenDrawer]);
  const handleContactUpdate = () => {
    setIsContactUpdated(true);
  };
  const handleOnChangeContact = e => {
    setUserContact(e.target.value);
    setShowWarning(false);
  };
  const handleLanguageUpdate = () => {
    setIsUpdateLanguage(true);
  };
  const handleOnChangeLanguage = value => {
    setDefaultLanguage(value);
  };
  const handleCancel = () => {
    const {
      userData
    } = props;
    setIsContactUpdated(false);
    setIsEditAvatarPicture(false);
    setCurrentAvatarPicture(userData === null || userData === void 0 ? void 0 : userData.profile_pic);
    setIsUpdateLanguage(false);
    setDefaultLanguage(userData === null || userData === void 0 ? void 0 : userData.preferred_language);
    if (isContactUpdated) {
      setUserContact(userData.phone);
    }
  };
  const handleSave = () => {
    const {
      updateUserDetailsData,
      apiBaseUrl,
      userData
    } = props;
    if (userData.phone !== userContact && userContact !== '' || defaultLanguage !== userData.preferred_language) {
      setIsUserDataUpdated(true);
      const payload = {
        phone: userContact,
        preferred_language: defaultLanguage
      };
      updateUserDetailsData(payload, apiBaseUrl).then(() => {
        setIsUserDataUpdated(false);
      });
    } else {
      setShowWarning(true);
    }
  };
  const handleUserLogOut = () => {
    logoutFromToken().then(() => {
      console.info("Token Invalidated from API!!!");
    }).finally(() => {
      TokenManager.clearAllCookies();
      TokenManager.clearTokenDetails();
    });
  };
  const handleRemovePicture = () => {
    const {
      apiBaseUrl,
      updateUserDetailsData
    } = props;
    showConfirm({
      title: __('Delete profile picture'),
      content: __('Are you sure want to delete profile picture?'),
      onOk: () => {
        setIsImageLoading(true);
        removeUserImageApi(apiBaseUrl).then(() => {
          notificationHelper('success', __('Success'), __('Profile picture removed successfully'), 5, () => {});
          setIsImageLoading(false);
          setIsEditAvatarPicture(true);
          updateUserDetailsData(_objectSpread(_objectSpread({}, userData), {}, {
            profile_pic: ''
          }), '', true);
        }, () => {
          notificationHelper('error', __('Error'), __('Error in removing profile picture'), 5, () => {});
        });
      }
    });
  };
  const getPreferredLanguage = () => {
    const preferredLanguage = LANGUAGE_OPTIONS.filter(data => {
      if (data.value === defaultLanguage) {
        return data;
      }
    });
    return preferredLanguage.length > 0 ? preferredLanguage[0].label : LANGUAGE_OPTIONS[0].label;
  };
  const onUpload = async _ref => {
    let {
      file
    } = _ref;
    const {
      apiBaseUrl,
      updateUserDetailsData
    } = props;
    setIsImageLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await uploadUserImageApi(apiBaseUrl, formData);
      setIsImageLoading(false);
      setIsEditAvatarPicture(true);
      notificationHelper('success', __('Success'), __('Profile picture updated successfully'), 5, () => {});
      setCurrentAvatarPicture(response.path);
      updateUserDetailsData(_objectSpread(_objectSpread({}, userData), {}, {
        profile_pic: response.path
      }), '', true);
      return response;
    } catch {
      notificationHelper('error', __('Error'), __('Error in uploading file'), 5, () => {});
    }
  };
  const disableLogout = isContactUpdated || isUpdateLanguage || isEditAvatarPicture;
  return /*#__PURE__*/React.createElement(Drawer, {
    title: __('Profile'),
    visible: true,
    width: 450,
    onClose: handleDrawerClose,
    className: "user-profile-drawer",
    maskClosable: !disableLogout
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawer-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawer-container-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawer-userProfile-inputWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "user-profile-avatar"
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    userName: {
      firstName: userData.firstName,
      lastName: userData.lastName
    },
    userProfilePicture: isEditAvatarPicture ? currentAvatarPicture : userData.profile_pic,
    onUpload: onUpload,
    isUpload: true,
    canDelete: true,
    isImageLoading: isImageLoading,
    onClickDelete: handleRemovePicture,
    isDrawerAvatar: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "user-details-wrapper"
  }, /*#__PURE__*/React.createElement(UserProfileItem, {
    label: __('First Name'),
    value: userData.firstName
  }), /*#__PURE__*/React.createElement(UserProfileItem, {
    label: __('Last Name'),
    value: userData.lastName
  }), /*#__PURE__*/React.createElement(UserProfileItem, {
    label: __('Email'),
    value: userData.email
  }), /*#__PURE__*/React.createElement(UserProfileItem, {
    label: __('Phone'),
    value: userContact,
    canEdit: true,
    onClickEdit: handleContactUpdate,
    isEditMode: isContactUpdated,
    onChange: handleOnChangeContact,
    showWarning: showWarning
  }), /*#__PURE__*/React.createElement(UserProfileItem, {
    label: __('Signed up on'),
    value: moment(userData.memberSince).format(dateFormat)
  }), (INTL_ENABLE === 'true' || INTL_ENABLE === true) && /*#__PURE__*/React.createElement(UserProfileItem, {
    label: __('Language Preference'),
    inputType: "Select",
    inputProps: {
      defaultValue: defaultLanguage,
      options: LANGUAGE_OPTIONS,
      size: 'small'
    },
    value: getPreferredLanguage(),
    canEdit: true,
    onClickEdit: handleLanguageUpdate,
    isEditMode: isUpdateLanguage,
    onChange: handleOnChangeLanguage
  }))), /*#__PURE__*/React.createElement("div", {
    className: "drawer-logout-wrapper"
  }, /*#__PURE__*/React.createElement(UserProfileLogout, {
    disableLogoutButton: disableLogout,
    onLogout: handleUserLogOut
  }))), showFooter && /*#__PURE__*/React.createElement("div", {
    className: "drawer-container-footer"
  }, /*#__PURE__*/React.createElement(UserProfileFooter, {
    handleCancel: handleCancel,
    handleSave: handleSave,
    disableSubmit: userData.phone === userContact && userData.preferred_language === defaultLanguage,
    isUserDataUpdated: isUserDataUpdated
  }))));
}
UserProfile.propTypes = {
  userData: PropTypes.object.isRequired,
  handleOpenDrawer: PropTypes.bool
};
UserProfile.defaultProps = {
  userData: EMPTY_OBJECT,
  handleOpenDrawer: false
};
export default UserProfile;